import makeStyles from '@material-ui/core/styles/makeStyles';

const DROPDOWN_MAX_HEIGHT = 500;
const DROPDOWN_MIN_WIDTH = 860;

export const useStyles = makeStyles((theme) => ({
  chips: {
    marginTop: 3,
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
  },
  chip: {
    height: 20,
    margin: '0 2px 2px 2px',
  },
  chipAncestors: {
    color: theme.palette.text.secondary,
    lineHeight: '20px',
    margin: '0 8px 2px 2px',
    whiteSpace: 'nowrap',
  },
  chipWithAncestors: {
    display: 'flex',
    alignItems: 'center',
    minWidth: 0,
  },
  columnTitle: {
    padding: '8px 12px',
    fontWeight: 600,
    borderBottom: '1px solid #efefef',
    position: 'sticky',
    top: 0,
    background: '#fff',
    zIndex: 2,
  },
  collapseButton: {
    padding: '2pt',
    height: 23,
    minWidth: 23,
    marginRight: 15,
    background: 'transparent',
  },
  emptyState: {
    padding: 12,
    color: theme.palette.text.secondary,
  },
  icon: {
    marginRight: '2pt',
    padding: 1,
  },
  iconOpened: {
    transform: 'rotate(180deg)',
  },
  input: {
    flexGrow: 1,
    flexShrink: 1,
    minWidth: '30%',
  },
  item: {
    padding: '2pt 0',
    alignItems: 'center',
    display: 'flex',
    borderBottom: '1px solid #efefef',
    fontFamily: theme.typography.fontFamily,
    minHeight: 26,
  },
  itemBadgeContent: {
    fontSize: 10,
    padding: 3,
    height: 'auto',
  },
  itemBadgeRoot: {
    marginLeft: 30,
    fontWeight: 300,
    verticalAlign: 'super',
  },
  itemBody: {
    alignItems: 'center',
    display: 'flex',
    flexGrow: 1,
    background: 'rgb(255 255 255 / 66%)',
  },
  paper: {
    width: `min(${DROPDOWN_MIN_WIDTH}px, calc(100vw - 32px))`,
    height: 'fit-content',
    minHeight: 26,
    maxHeight: DROPDOWN_MAX_HEIGHT,
    overflow: 'hidden',
  },
  popper: {
    width: `min(${DROPDOWN_MIN_WIDTH}px, calc(100vw - 32px))`,
    zIndex: 1500,
  },
  popupLayout: {
    display: 'flex',
    alignItems: 'stretch',
    maxHeight: DROPDOWN_MAX_HEIGHT,
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      width: '100%',
    },
  },
  resultsColumn: {
    flex: '1 1 auto',
    minWidth: 0,
    maxHeight: DROPDOWN_MAX_HEIGHT,
    overflowY: 'auto',
    borderRight: '1px solid #efefef',
    [theme.breakpoints.down('sm')]: {
      borderRight: 'none',
      borderBottom: '1px solid #efefef',
    },
  },
  selectedChips: {
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'column',
    alignContent: 'flex-start',
    alignItems: 'flex-start',
    gap: '8px',
    padding: 10,
  },
  selectedColumn: {
    flex: '0 0 400px',
    maxHeight: DROPDOWN_MAX_HEIGHT,
    overflowY: 'auto',
    background: '#fafafa',
    [theme.breakpoints.down('sm')]: {
      flex: '1 1 auto',
    },
  },
  wrapper: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: theme.palette.editing,
  },
  wrapperDisabled: {
    backgroundColor: 'inherit',
  },
}));
